import { render, staticRenderFns } from "./PchTaxDocumentList.vue?vue&type=template&id=11a52a87&lang=pug&"
import script from "./PchTaxDocumentList.vue?vue&type=script&lang=js&"
export * from "./PchTaxDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchTaxDocumentList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VDialog,
  VIcon,
})
